import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { Store } from "@ngrx/store";
import { AuthenticationStatus, AuthSelector, CORE_ROUTE, CoreState } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";
import { Observable } from "rxjs";
import { filter, map, take } from "rxjs/operators";
import "typings";

import { CookieConsentConfigService } from "../cookie-consent/cookie-consent.config";

@Injectable({
	providedIn: "root",
})
export class CookieSettingsDataProtectionGuard implements CanActivate {
	constructor(
		private store: Store<CoreState>,
		private configService: CookieConsentConfigService
	) {}

	canActivate(): Observable<boolean> {
		return this.store.select(AuthSelector.getAuthenticationStatus).pipe(
			filter((status) => status !== AuthenticationStatus.Pending),
			take(1),
			map((status) => {
				if (this.configService.getOneTrustIsEnabled()) {
					/* When the user goes directly to the cookie setting,
						the guard is running first which results in oneTrust being undefined. */
					if (typeof OneTrust === "undefined") {
						/* From the app component/messages, we check the route with query param: thirdPartyCookieSystem
							to open oneTrust */
						this.store.dispatch(
							RouteAction.navigate(CORE_ROUTE.home, undefined, {
								queryParams: { thirdPartyCookieSystem: true },
							})
						);
					} else {
						OneTrust.ToggleInfoDisplay();
					}
					return false;
				}
				if (status === AuthenticationStatus.Authenticated) {
					this.store.dispatch(RouteAction.navigate(CORE_ROUTE.marketingSettings.root));
					return false;
				}
				return true;
			})
		);
	}
}
